import { render, staticRenderFns } from "./vime.vue?vue&type=template&id=5aed4c74"
import script from "./vime.vue?vue&type=script&lang=js"
export * from "./vime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports